export const roundToTwo = (number: number | string) => {
  const num = typeof number === 'string' ? Number(number) : number;
  return Math.round((num + Number.EPSILON) * 100) / 100;
};
